














import Vue from "vue";
import AppLogin from "./components/app/AppLogin.vue";
import AppHeader from "./components/app/AppHeader.vue";
import AppNavigation from "./components/app/AppNavigation.vue";
import AppNotifications from "./components/app/AppNotifications.vue";

import { Component } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";

@Component({
  components: {
    AppLogin,
    AppHeader,
    AppNavigation,
    AppNotifications,
  },
})
export default class App extends Vue {
  @Action("loginWithToken", { namespace: "auth" }) loginWithToken: any;
  @Action("logout", { namespace: "auth" }) logout: any;
  @Getter("isAuthenticated", { namespace: "auth" }) isAuthenticated: any;

  mounted() {
    //see if valid local storage credentials exist
    let cToken = localStorage.getItem("asea.token");
    let cTokenExpiration = parseInt(
      localStorage.getItem("asea.token.expiration") || "0"
    );
    let now = new Date().getTime();

    if (now < cTokenExpiration) {
      var username = localStorage.getItem("asea.user.name");
      this.loginWithToken({ username: username, token: cToken });
    }
    let currentUrl = window.location.href;
  }
}
